import { CalendarCheck, MapPin, Droplets, Car } from "lucide-react";

const steps = [
  { icon: CalendarCheck, num: "01", title: "Richiedi Preventivo", desc: "Compila il form o scrivici su WhatsApp. Ti contattiamo in breve tempo con un preventivo su misura." },
  { icon: MapPin, num: "02", title: "Arriviamo da Te", desc: "Ci presentiamo con il nostro gazebo completo di attrezzatura. Nessuna infrastruttura richiesta." },
  { icon: Droplets, num: "03", title: "Lavaggio Nanotech", desc: "Applichiamo la formula waterless: sporco sollevato, carrozzeria protetta, zero acqua sprecata." },
  { icon: Car, num: "04", title: "Wash & Go", desc: "La tua auto è pronta: brillante, igienizzata, protetta. Sali e goditi la strada." },
];

export default function HowItWorks() {
  return (
    <section id="come-funziona" data-testid="how-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-px bg-nexa-blue" />
              <span className="overline">Come Funziona</span>
            </div>
            <div className="heading text-3xl md:text-5xl text-white leading-tight">
              Un processo in <span className="text-nexa-blue">quattro step.</span>
            </div>
          </div>
          <p className="text-nexa-muted text-base max-w-md">
            Dall'appuntamento alla consegna: tutto pensato per essere semplice, rapido e sostenibile.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} data-testid={`step-${i}`} className="relative">
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-gradient-to-r from-nexa-blue/40 to-transparent -translate-x-1/2 z-0" />
                )}
                <div className="card-surface p-7 relative z-10 h-full">
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-12 h-12 flex items-center justify-center border border-nexa-blue/30 bg-nexa-blue/5">
                      <Icon size={22} className="text-nexa-blue" />
                    </div>
                    <span className="heading text-3xl chrome-text opacity-60">{s.num}</span>
                  </div>
                  <div className="heading text-lg uppercase tracking-wider text-white mb-2">{s.title}</div>
                  <p className="text-sm text-nexa-muted leading-relaxed">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
